import { jsxs } from "react/jsx-runtime";
import { createContext } from "react";
import { message } from "antd";
import { buildToastInstance } from "./abstract.js";
const ToastProviderContext = /*#__PURE__*/ createContext(null);
const useToastWithContextHolder = ()=>{
    const [messageApi, contextHolder] = message.useMessage();
    const toastInstance = buildToastInstance(messageApi);
    return [
        toastInstance,
        contextHolder
    ];
};
const ToastProvider = ({ children })=>{
    const [toastInstance, contextHolder] = useToastWithContextHolder();
    return /*#__PURE__*/ jsxs(ToastProviderContext.Provider, {
        value: toastInstance,
        children: [
            children,
            contextHolder
        ]
    });
};
export { ToastProvider, ToastProviderContext, useToastWithContextHolder };
